import { render, staticRenderFns } from "./productionStageSummaryWidget.vue?vue&type=template&id=c27b35b0&"
import script from "./productionStageSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./productionStageSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports